module.exports = __webpack_public_path__ + "img/home_top.0cbe4ccb.jpg";